<template>
  <v-container style="height: 100%" class="bg-glass-effect-lighter px-3 py-2 fh" fluid>
    <v-row class="px-6 py-5 notification-header" justify="center" align="center" >
      <v-col class="pa-0 ma-0" cols="1">
        <v-btn icon color="error" @click="()=>($router.push({name: 'message'}))">
          <img style="width: 28px; height: 23px; -webkit-transform: scaleX(-1); transform: scaleX(-1);"  src="/img/icons/sidebar/right-arrow.svg"/>
        </v-btn>
      </v-col>
      <v-col class="pl-8 pa-0 ma-0" cols="2">
        <v-avatar size="48">
          <img :src="sender.thumbnail" >
        </v-avatar>
      </v-col>
      <v-col class="pa-0 ma-0" cols="9">
        <p class="text-center pa-0 ma-0 sender-name fill-height align-content-center justify-center">{{sender.name}}</p>
      </v-col>
    </v-row>
    <v-row id="notification-body" class="px-6 fh notification-body"  >
      <div class="d-flex flex-column-reverse fw " v-for="allMessages in getAllMessages()" :key="allMessages.senderId" >
        <v-card
                v-for="message in allMessages.messages"
                :key="message.id"
                class="notification-card pa-4 my-2"
                outlined
                tile
        >
          <p class="notification-text">
             {{ message.message.body }}
          </p>

          <v-card v-if="message.message.messageType" class="message-inside-card mt-2" :set="messageInside = JSON.parse(message.message.messageType)" @click="navigateMessage(messageInside)">
            <v-card-text class="py-0 px-3">
              <v-row class="py-0">
                <v-col cols="2" class="mt-0">
                  <v-avatar v-if="messageInside.icon" color="red" size="32" >
                    <v-icon color="white" small>{{messageInside.icon}}</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="10" class="pr-2">
                  <p class="message-inside-title">{{ messageInside.title }}</p>
                  <p class="message-inside-text">{{ messageInside.text }}</p>
                  <p v-if=" messageInside.remember" class="message-inside-remember mt-2"><v-icon class="mr-2" style="color: lightgray" small>far fa-bell</v-icon>{{ messageInside.remember }}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-row justify="center">
            <v-col cols="12" align="center">
              <generic-btn v-if="hasDomainOriginAndEventId(message)" :btn-props="{ rounded: true }"
                           :on-click="() => onClickCard(message)">
                Detalhar
              </generic-btn>
            </v-col>
          </v-row>

          <p class="message-time text-right ma-0 pt-5">
            {{ getMessageDate(message.message.sentDateTime) }}
          </p>
        </v-card>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import MessageService from "../../services/socialnetwork/MessageService";
import SocialNetworkService from "../../services/socialnetwork/SocialNetworkService";
import GenericBtn from "../../components/generic-btn";
import store from "../../store/store";
import {mapGetters, mapMutations} from "vuex";
import moment from "moment"
export default {
  name: "chat",
  components: {
    GenericBtn
  },
  data: () => ({
    sender : {}
  }),
  async created () {
    this._messageService = new MessageService();
    this._socialNetworkService = new SocialNetworkService();
    moment.locale('pt-br');
    this.loading(true);
    await this.registerReadPushNotification();
    this.loading(false);
    this.loadSender();
    this.loadMessages();
  },
  methods:{
    ...mapMutations(['loading', 'setAllMessagesBySender']),
    ...mapGetters(["getAllMessages"]),
    onClickCard(message){
      if(this.hasDomainOriginAndEventId(message)){
        switch (message.message.domainOrigin) {
          case 'EXAM_EVENT':
            this.$router.push({name: 'exames', params: {id: message.message.eventId}})
            break;
          case 'MEDICAL_APPOINTMENT_EVENT':
            this.$router.push({name: 'appointment', params: {id: message.message.eventId}})
            break;
          case 'VACCINE_EVENT':
            this.$router.push({name: 'vaccine', params: {id: message.message.eventId}})
            break;
          default:
        }
      }
    },
    hasDomainOriginAndEventId(message){
      return message && message.message && message.message.domainOrigin && message.message.eventId;
    },
    loadSender(){
      if(this.$route.params && this.$route.params.sender && this.$route.params.sender.id){
        this.sender = this.$route.params.sender;
        this.loadSenderEntityInfo();
      }
    },
    async registerReadPushNotification(){
      if(this.$route.params && this.$route.params.messageId){
        await this.markReadPushNotification(this.$route.params.messageId)
      }
    },
    loadSenderEntityInfo(){
      this._socialNetworkService.FindEntityById(this.sender.id)
          .then((response) => {
            if(response.data){
              this.sender = response.data;
            }
          })
    },
    async markReadPushNotification(messageId){
      await this._socialNetworkService.MarkReadByMessageId(messageId).then(() => {})
    },
    loadMessages(){
      this.loading(true);
      this.sender = this.$route.params.sender;
      this.messagesGroupingBySender = this.getAllMessagesBySender(this.sender.id);
      this._messageService.GetMessagesBySender(this.sender.id)
        .then((response) => {
          const messages = {
            senderId: this.sender.id,
            messages: response.data.content
          }
          this.setAllMessagesBySender(messages);
        })
        .catch(error => {
          store.commit('showmsg', { text: "Erro ao listar Mensagens", type: "error" });
        })
        .finally(() => {
          this.loading(false);
        })
    },
    getAllMessagesBySender(){
      if(!this.sender.id)
        return [];

      let messagesBySender = this.getAllMessages().find(m => {
        return m.senderId == this.sender.id
      });

      return messagesBySender ? messagesBySender.messages : [];
    },
    getMessageDate(date){
      const today = moment().format('L');
      const messageDate = moment(date).format('L');
      return (today == messageDate) ? moment(date).format('LT') : moment(date).format("DD [de] MMMM");
    },
    navigateMessage(message){
      //TODO go to route by type and params
    }
  }
}
</script>

<style scoped>
  .notification-header{
    background-color: var(--v-primary);
    position: fixed;
    z-index: 1;
    width: 100%;
  }

  .notification-body {
    max-height: calc(100vh - 100px) !important;
    overflow: visible !important;
    position: relative;
    overflow-y: scroll !important;
    top: 9%;
  }

  .sender-name{
    font-family: "Open Sans";
    color: var(--v-white);
    font-size: 18px;
  }

  .notification-card {
    background-color: var(--v-snackbar);
    border-radius: 25px 25px 25px 10px !important;
  }

  .notification-text {
    font-family: "Open Sans";
    line-height: 25px;
    font-size: 16px;
  }

  .message-time{
    font-family: "Open Sans";
    font-size: 14px;
    color: var(--v-gray500);
  }

  .message-inside-card {
    max-width: 97% !important;
    min-width: 97% !important;
    background-color: var(--v-primary);
    border-radius: 25px 25px 25px 25px !important;
  }

  .message-inside-title{
    color: var(--v-white);
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    margin-bottom: 5px;
  }

  .message-inside-text {
    color: var(--v-white);
    font-family: "Open Sans";
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 5px;
  }

  .message-inside-remember {
    color: lightgray;
    font-family: "Open Sans";
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 5px;
  }
</style>


